<template>
    <wizard-step-card
            header="Bitte geben Sie weitere Details an!"
            :reason="_getCurrentReason"
            btnDoneName="Abschließen"
            v-on:stepdone="stepDone"
            v-on:abbort="$emit('abbort')"
    >

        <div class="row">

            <div class="col-6">

                <info-header icon="far fa-edit">
                    <template slot="titel">
                        Welche Lösung wünschen Sie?
                    </template>

                    <template slot="leed">
                        Wählen Sie aus welche Lösung Sie bevorzugen.
                    </template>
                </info-header>

                <div>

                    <select-item  value="Retoure" v-on:select="_option='Retoure'" :active="'Retoure'===_option"> Ich möchte den Artikel zurück geben </select-item>

                    <select-item  value="Preisnachlass" v-on:select="_option='Preisnachlass'" :active="'Preisnachlass'===_option"> Ich möchte einen Preisnachlass erhalten </select-item>

                </div>

            </div>

            <div class="col-6">

                <info-header icon="far fa-edit">
                    <template slot="titel">
                        Möchten Sie uns noch etwas mitteilen?
                    </template>

                    <template slot="leed">
                        Weitere Fragen können Sie diese hier eintragen.
                    </template>
                </info-header>

                <customer-discription name="additionalText" height="147" v-on:setText="_setText"> </customer-discription>

            </div>

        </div>

    </wizard-step-card>
</template>

<script>
    import InfoHeader from '../../elements/InfoHeader'
    import WizardStepCard from '../../elements/WizardStepCard'
    import CustomerDiscription from '../../elements/CustomerDiscription'
    import SelectItem from '../../elements/SelectItem'

    export default {
        name: "last-step_return",
        components: {
            WizardStepCard,
            InfoHeader,
            CustomerDiscription,
            SelectItem
        },

        data: () => ({
            option: false
        }),

        computed: {

            _option: {

                get () {
                    return this.$store.getters.getSolveWish
                },

                set (newValue) {
                    this.$store.commit('setSolveWish', newValue)
                }
            },

            _getCurrentReason () {

                let reasonCode = this.$store.getters.getReason

                return this.$store.getters.getReasons[ reasonCode ] || 'Fehler - nicht gefunden!'
            }
        },

        methods: {

            _setText (obj) {

                let { name, value } = obj

                this.$store.commit('setText', { name, value })
            },

            stepDone () {

                // Form validation
                const form = this.$store.getters.getForm


                // Check options
                if( !form.solveWish ){
                    this.$swal({
                        title: 'FEHLER',
                        text: 'Bitte wählen Sie eine mögliche Lösung!',
                        icon: 'error'
                    })

                    return true
                }

                this.$emit('stepdone')
            }
        }
    }
</script>

<style scoped>

</style>